angular.module('env.data.httpInterceptors.jsonResponseInterceptor', [])

    // Insert 'Accept:"application/json"' header for every api call.
    // This needs for valid json response from server when error was happened, instead of html page.
    .factory('jsonResponseInterceptor', function ($q) {
        return {
            request: function (request) {
                if (request.url.indexOf('api/') !== -1) {
                    request.headers = request.headers || {};
                    request.headers.Accept = "application/json";
                }
                return request || $q.when(request);
            }
        };
    })

;
